import React, { useEffect } from 'react'
import { Column } from 'primereact/column'
import { useIntl } from 'react-intl'
import { ColumnGroup } from 'primereact/columngroup'
import { Row } from 'primereact/row'
import { DataTableFun } from '../../../utils/helpers/dataTableFun'
import DataTableComp from '../../common/data-table/DataTableComp'
import { formatCurrency, formatPercent } from '../../../utils/helpers/common'
import './summary-datatable.scss'

const SummaryDataTable = ({ value, sortOptions, pagerOptions }) => {
  const { formatMessage: msg } = useIntl()
  const dataTablePaddingBottom = 80

  useEffect(() => {
    // BEGIN: DataTable Responsive Pattern
    window.addEventListener(
      'resize',
      DataTableFun.responsiveResize(dataTablePaddingBottom),
    )
    return () => {
      window.removeEventListener(
        'resize',
        DataTableFun.responsiveResize(dataTablePaddingBottom),
      )
    }
    // END: DataTable Responsive Pattern
  }, [])

  const customFormatCurrency = (val) => formatCurrency(val, {}, true)

  const renderMargin = (marginData) => (
    <span style={{ whiteSpace: 'nowrap' }}>
      <span style={{ whiteSpace: 'nowrap' }}>
        {marginData?.margin && customFormatCurrency(marginData?.margin)}
        {marginData?.margin && <span> /l</span>}
      </span>
      <span style={{ whiteSpace: 'nowrap' }}>
        {marginData?.margin && marginData?.percentage && <br />}
        {formatPercent(marginData?.percentage)}
      </span>
    </span>
  )

  const renderComparison = (comparisonData) =>
    comparisonData && (
      <span>
        <span className="station">{comparisonData?.stationName}</span>
        {comparisonData?.GOA?.price && (
          <span
            className={`badge ${comparisonData?.GOA?.isOK ? 'isOK' : 'isNOK'}`}
          >
            {customFormatCurrency(comparisonData?.GOA?.price)}
          </span>
        )}
        {comparisonData?.G95?.price && (
          <span
            className={`badge ${comparisonData?.G95?.isOK ? 'isOK' : 'isNOK'}`}
          >
            {customFormatCurrency(comparisonData?.G95?.price)}
          </span>
        )}
      </span>
    )

  const renderHeaderGroup = (
    <ColumnGroup>
      <Row>
        <Column field="centerName" header={msg({ id: 'center' })} sortable />
        <Column header="GOA" align="center" colSpan={2} />
        <Column header="G95" align="center" colSpan={2} />
        <Column
          header={msg({ id: 'competence' }).concat(' 1')}
          align="center"
        />
        <Column
          header={msg({ id: 'competence' }).concat(' 2')}
          align="center"
        />
        <Column
          header={msg({ id: 'competence' }).concat(' 3')}
          align="center"
        />
      </Row>
      <Row>
        <Column />
        <Column header={msg({ id: 'price' })} align="center" />
        <Column header={msg({ id: 'margin' })} align="center" />
        <Column header={msg({ id: 'price' })} align="center" />
        <Column header={msg({ id: 'margin' })} align="center" />
        <Column />
        <Column />
        <Column />
      </Row>
    </ColumnGroup>
  )

  return (
    <DataTableComp
      pagerOptions={pagerOptions}
      tableOptions={{
        headerColumnGroup: renderHeaderGroup,
        className: 'fuel-stations-summary-datatable',
        scrollable: true,
        scrollHeight: DataTableFun.responsiveHeight(dataTablePaddingBottom),
        value,
        size: 'small',
        ...sortOptions,
      }}
      columns={[
        <Column
          field="centerName"
          className="border-right"
          style={{ width: '10%', minWidth: '200px' }}
          sortable
        />,
        <Column
          field="priceGOA"
          className="price-col alt-col border-left"
          body={(rowData) => customFormatCurrency(rowData?.priceGOA)}
        />,
        <Column
          field="marginGOA"
          className="price-col alt-col"
          body={(rowData) => renderMargin(rowData?.marginGOA)}
        />,
        // <Column
        //     field="priceGOAPLUS"
        //     className="price-col border-left"
        //     body={(rowData) => customFormatCurrency(rowData?.priceGOAPLUS, {minimumFractionDigits: 3})}
        // />,
        <Column
          field="priceG95"
          className="price-col border-left"
          body={(rowData) => customFormatCurrency(rowData?.priceG95)}
        />,
        <Column
          field="marginG95"
          className="price-col"
          body={(rowData) => renderMargin(rowData?.marginG95)}
        />,

        <Column
          field="comparison1"
          className="comparison-col border-left alt-col"
          body={(rowData) => renderComparison(rowData?.comparison1)}
        />,
        <Column
          field="comparison2"
          className="comparison-col border-left"
          body={(rowData) => renderComparison(rowData?.comparison2)}
        />,
        <Column
          field="comparison3"
          className="comparison-col border-left alt-col"
          body={(rowData) => renderComparison(rowData?.comparison3)}
        />,
      ]}
    />
  )
}

export default SummaryDataTable
